var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.selectAll == true)?_c('div',{staticClass:"trivia-title"},[_c('h1',[_vm._v(_vm._s(_vm.title)+" "),_c('span',[_vm._v("(Select all that apply)")])])]):_c('div',{staticClass:"trivia-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }